import { render, staticRenderFns } from "./ComboChoices.vue?vue&type=template&id=44e02991&scoped=true"
import script from "./ComboChoices.vue?vue&type=script&lang=js"
export * from "./ComboChoices.vue?vue&type=script&lang=js"
import style0 from "./ComboChoices.vue?vue&type=style&index=0&id=44e02991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e02991",
  null
  
)

export default component.exports